import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import {
  DatasetPieChart,
  PieChartParams,
} from 'src/app/shared/pie-chart/models/pie-chart.model';
import { PieChartComponent } from 'src/app/shared/pie-chart/pie-chart.component';
import { DashboardService } from '../service/dashboard.service';
import {
  DashboardFilterRequest,
  FirstCallResolutionResponse,
} from '../service/models/dashboard.service.model';

@Component({
  selector: 'app-dashboard-first-call-resolution',
  templateUrl: './dashboard-first-call-resolution.component.html',
  styleUrls: ['./dashboard-first-call-resolution.component.scss'],
})
export class DashboardFirstCallResolutionComponent {
  @Input() filter!: DashboardFilterRequest;

  @ViewChild(PieChartComponent) pieChartComponent!: PieChartComponent;

  data: FirstCallResolutionResponse = {} as FirstCallResolutionResponse;
  loading: boolean = false;
  error: boolean = false;
  params!: PieChartParams;

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnChanges() {
    this.getDashboardData();
  }

  generate() {
    const datasetPie: DatasetPieChart = {
      values: [this.data.resolved.toString(), this.data.unresolved.toString()],
      backgroundColor: ['rgba(3, 105, 161, 1)', 'rgba(239, 68, 68, 1)'],
      borderColor: undefined,
      borderWidth: 1,
    };

    this.params = {
      footerOptions: ['Resolvidos na primeira ligação', 'Não Resolvidos'],
      datasets: [datasetPie],
    };

    this.createChart();
  }

  createChart() {
    this.pieChartComponent.createChart(this.params, 'firstCallChart');
  }

  getDashboardData() {
    this.loading = true;
    this.error = false;
    this.cdr.detectChanges();

    this.dashboardService.getFirstCallResolution(this.filter).subscribe({
      next: (data) => {
        this.data = data;
        this.generate();
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.error = true;
        this.cdr.detectChanges();
      },
    });
  }
}
